import Vue from 'vue'
import iView from 'iview'
import iviewArea from 'iview-area';
Vue.use(iviewArea);
Vue.use(iView);
import 'iview/dist/styles/iview.css'
